// extracted by mini-css-extract-plugin
export default {"footer":"eG6zL+F7Q5EON-AfP212WQ==","report":"ljy-NtOfb8QwxLP7cNXiLw==","footerMain":"FhtMo9w9IQDCNabrvRHA8Q=="};